import { render, staticRenderFns } from "./goodsItemView.vue?vue&type=template&id=1c5cd84e&"
import script from "./goodsItemView.vue?vue&type=script&lang=js&"
export * from "./goodsItemView.vue?vue&type=script&lang=js&"
import style0 from "./goodsItemView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports